import React from 'react';
import PropTypes from 'prop-types'
import classNames from 'classnames';
import Search1 from "../../images/search1.svg";
export default class FloatingInput extends React.Component {
  constructor(props) {
    super(props);
    this.inputRef = React.createRef();
  }

  handleDivClick = () => {
    if (this.inputRef.current) {
      this.inputRef.current.focus();
    }
  };

  onChange = (event) => {
    this.props.onChange(event.target.value, event.target.name);
  }

  clearInput = () => {
    this.props.onChange('');
  }

  render() {
    const {
      type,
      value,
      name,
      errorMsg,
      // onChange,
      withClear,
      // showError,
      // fieldType,
      placeholder,
      customClass='',
      onFocus,
      disabled,
      shouldHideCrossIcon=false,
      dealListPresent=false,
      lastMinute=false,
      compData=false
     } = this.props;
     const inputClasses = classNames('fl-input', { 'fl-valid': value !== '' && type==='number'? value>=0: value }); //, { 'fl-valid': hasValue && !hasError && value !== '' }, { 'fl-invalid': hasValue && hasError }
     const customClasses = classNames('text-input', { 'fl-valid': value !== '' && type==='number'? value>=0: value }); //, { 'fl-valid': hasValue && !hasError && value !== '' }, { 'fl-invalid': hasValue && hasError }
    const errMsgClasses = classNames({ 'fl-error-msg': errorMsg }, { 'fl-error-show': errorMsg });
    const searchClasses = classNames('search-box1');
    const inputClasses1 = classNames('fl-input fl-input-borderBottom ', { 'fl-valid': value !== '' && type==='number'? value>=0: value }); //, { 'fl-valid': hasValue && !hasError && value !== '' }, { 'fl-invalid': hasValue && hasError }

    return (
      <div className={dealListPresent ? compData ? 'fl-container1' : 'fl-container' : `fl-input-container ${customClass}`} onClick={this.handleDivClick}>
        {
          withClear && value && !disabled && !shouldHideCrossIcon &&
            <div className={dealListPresent ? "text-input-clear" :"fl-input-clear"} onClick={this.clearInput} />
        }
        {dealListPresent && <img src={Search1} className={searchClasses} onClick={this.onChange} />}
        <input
         ref={this.inputRef} 
          type={type}
          id={placeholder}
          name={name}
          value={value}
          disabled={disabled}
          className={dealListPresent ? customClasses : (lastMinute ? inputClasses1 : inputClasses)}
          onChange={this.onChange}
          onFocus={onFocus || null}
        />
        {dealListPresent ? value === '' && <label className="fl-text" htmlFor={placeholder}>{placeholder}</label> :
        <label className="fl-input-label" htmlFor={placeholder}>
          {placeholder}
        </label>
        }

        <span className="fl-input-bar" />
        { errorMsg && <span className={errMsgClasses}>{errorMsg}</span> }
      </div>
    );
  }
}

FloatingInput.defaultProps = {
  type: 'text',
};

FloatingInput.propTypes = {
  onChange: PropTypes.func,
  withClear: PropTypes.bool,
  showError: PropTypes.bool,
  errorMsg: PropTypes.string,
  type: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  // pattern: PropTypes.any,
  // isDisabled: PropTypes.bool,
  // onBlur: PropTypes.func,
  // onFocus: PropTypes.func,
  // onClear: PropTypes.func,
  // tabIndex: PropTypes.string,
};